export class NamedStack {
  protected objects: any[] = [];
  protected keys: string[] = [];

  public push(key: string, obj: any): NamedStack {
    this.keys.push(key);
    this.objects.push(obj);
    return this;
  }

  public uppush(key: string, obj: any, onConflict: (old, nw) => void): NamedStack {
    const idx = this.keys.indexOf(key);
    if (~idx) {
      onConflict(this.objects[idx], obj);
      return this;
    }
    return this.push(key, obj);
  }

  public removeNamed(key) {
    const idx = this.keys.indexOf(key);
    if (~idx) {
      this.objects.splice(idx, 1);
      this.keys.splice(idx, 1);
    }
  }

  public remove(obj) {
    const idx = this.objects.indexOf(obj);
    if (~idx) {
      this.objects.splice(idx, 1);
      this.keys.splice(idx, 1);
    }
  }

  public hasNamed(key): boolean {
    return Boolean(~this.keys.indexOf(key));
  }

  public map(fn: (o, k, i, objs, keys) => any[]) {
    return this.objects.map((o, i) => fn(o, this.keys[i], i, this.objects, this.keys));
  }

}